<style scoped>
.hostContainer.box {
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
}

.franchiseSelector {
  padding-left: 10px;
  margin-top: 10px;

  span {
    margin-right: 10px;
  }

  div {
    min-width: 275px;
    margin-top: -2px;
  }
}

.v-select.single.open .selected-tag {
  position: relative !important;
}

input[type='text'] {
  height: 30px;
  width: 100%;
}
</style>
<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div
        v-if="!receivedFranchises || showLoading"
        class="spinner-loader"
    >
      <sync-loader/>
      Loading...
    </div>
    <div v-if="receivedFranchises && !showLoading">
      <div class="columns">
        <div class="column is-12">
          <div class="div-table">
            <div class="columns is-gapless">
              <div class="column is-12 card-header has-text-centered button-tools">
                <strong>Edit point race</strong>
              </div>
            </div>
            <div class="column is-12">
              <div class="columns">
                <div class="column is-12">
                  <toggle-button
                      v-model="params.active"
                      :width="80"
                      :height="30"
                      :speed="480"
                      :sync="true"
                      :labels="{checked: 'Active', unchecked: 'Inactive'}"
                      :color="{checked: '#7DCE94', unchecked: '#CCC'}"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  <label class="label">Franchise:</label>
                </div>
                <div class="column is-4">
                  <v-select
                      v-model="selectedFranchise"
                      :options="franchises"
                      label="name"
                  />
                </div>
              </div>
              <div class="columns">
                <br>
                <i>This is all one word, and is unique to identify this tab when viewing points</i>
              </div>
              <div class="columns">
                <div class="column is-2">
                  <label class="label">Tab name:</label>
                </div>
                <div class="column is-9">
                  <v-text-field
                      v-model="params.name"
                      type="text"
                  />
                </div>
              </div>
              <div class="columns">
                <br>
                <i>This is what the user will see on the tab itself</i>
              </div>
              <div class="columns">
                <div class="column is-2">
                  <label class="label">Tab text:</label>
                </div>
                <div class="column is-9">
                  <v-text-field
                      v-model="params.tablabel"
                      type="text"
                  />
                </div>
              </div>
              <div class="columns">
                <br>
                <i>Tabs are ordered from Low to High, so start at 0 if you want this to be in the beginning</i>
              </div>
              <div class="columns">
                <div class="column is-2">
                  <label class="label">Tab order:</label>
                </div>
                <div class="column is-9">
                  <v-text-field
                      v-model="params.torder"
                      type="text"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  <label class="label">Return Count:</label>
                </div>
                <div class="column is-9">
                  <v-text-field
                      v-model="params.retcount"
                      type="text"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  <label class="label">List Type:</label>
                </div>
                <div class="column is-4">
                  <v-select
                      v-model="selectedListType"
                      :options="listTypes"
                      label="name"
                  />
                </div>
              </div>
              <div
                  v-if="selectedListType.value === 4"
                  class="columns"
              >
                <br>
                <i>From date to date for specific ranged lists. Leave blank if not needed (Format: YYYY-MM-DD)</i>
              </div>
              <div
                  v-if="selectedListType.value === 4"
                  class="columns"
              >
                <div class="column is-2">
                  <label class="label">Date range:</label>
                </div>
                <div class="column is-9">
                  <v-text-field
                      v-model="params.date1"
                      type="text"
                  /> to <v-text-field
                    v-model="params.date2"
                    type="text"
                />
                </div>
              </div>
              <div
                  v-if="selectedListType.value <= 3 && selectedListType.value > 0"
                  class="columns"
              >
                <br>
                <i>A number that is less than or equal to 0. (Example: {{ selectedListType.name }} before last:-2, Last
                  {{ selectedListType.name }}: -1, This {{ selectedListType.name }}:
                  0)</i>
              </div>
              <div
                  v-if="selectedListType.value <= 3 && selectedListType.value > 0"
                  class="columns"
              >
                <div class="column is-2">
                  <label class="label">Last/Current {{ selectedListType.name }}:</label>
                </div>
                <div class="column is-9">
                  <v-text-field
                      v-model="params.lastcurr"
                      type="text"
                  />
                </div>
              </div>

              <div
                  v-if="selectedListType.value === 5"
                  class="columns"
              >
                <br>
                <i>Comma separated list of AHL Numbers</i>
              </div>
              <div
                  v-if="selectedListType.value === 5"
                  class="columns"
              >
                <div class="column is-2">
                  <label class="label">Manual AHL Numbers:</label>
                </div>
                <div class="column is-9">
                  <v-text-field
                      v-model="params.manahlnums"
                      type="text"
                  />
                </div>
              </div>

              <div class="columns">
                <div class="column is-2">
                  <label class="label">Please choose a point table:</label>
                </div>
                <div class="column is-4">
                  <v-select
                      v-model="selectedPointType"
                      :options="pointTypes"
                      label="name"
                  />
                </div>
              </div>
              <div class="columns">
                <br>
                <i>The header text of the list. (Example: Top 150 players of the year)</i>
              </div>
              <div class="columns">
                <div class="column is-2">
                  <label class="label">Header text:</label>
                </div>
                <div class="column is-9">
                  <v-text-field
                      v-model="params.list_label"
                      type="text"
                  />
                </div>
              </div>

              <div class="columns">
                <br>
                <i>The venue id to pull the list from, leave blank if overall for the region</i>
              </div>
              <div class="columns">
                <div class="column is-2">
                  <label class="label">Venue ID:</label>
                </div>
                <div class="column is-9">
                  <v-text-field
                      v-model="params.venid"
                      type="text"
                  />
                </div>
              </div>

              <div class="columns">
                <br>
                <i>The tournament mark to match against, leave blank if not required for this list
                  Examples:
                  <br>&nbsp;&nbsp;<strong>'abc'</strong> matches: <strong>'abc'</strong> but not '<strong>abcd</strong>'
                  <br>&nbsp;&nbsp;<strong>'abc%'</strong> matches: <strong>'abc'</strong> and '<strong>abcd</strong>'
                  <br>&nbsp;&nbsp;<strong>'%abc'</strong> matches: <strong>'abc'</strong> and '<strong>123abc</strong>'
                  <br>&nbsp;&nbsp;<strong>'%abc%'</strong> matches: <strong>'abc'</strong> and
                  '<strong>123abcdefg</strong>'
                </i>
              </div>
            </div>
            <div class="columns">
              <div class="column is-2">
                <label class="label">Event Tag:</label>
              </div>
              <div class="column is-9">
                <v-select
                    v-model="params.eventTag"
                    :options="eventTags"
                    label="name"
                />
              </div>
            </div>
            <div class="columns">
              <div class="column is-2">
                <label class="label">Tournament mark:</label>
              </div>
              <div class="column is-9">
                <v-text-field
                    v-model="params.tmark"
                    type="text"
                />
              </div>
            </div>

            <div class="columns">
              <br>
              <i>Helptext (A link is added to the top of the points page to help players understand the point of the
                list)</i>
            </div>
            <div class="columns">
              <div class="column is-2">
                <label class="label">Help text:</label>
              </div>
              <div class="column is-9">
                <v-text-field
                    v-model="params.helptext"
                    type="text"
                />
              </div>
            </div>

            <div class="columns">
              <br>
              <i>Helplink (The URL to point the Help Text to) </i>
            </div>
            <div class="columns">
              <div class="column is-2">
                <label class="label">Help link:</label>
              </div>
              <div class="column is-9">
                <v-text-field
                    v-model="params.helplink"
                    type="text"
                />
              </div>
            </div>


            <div class="columns">
              <br>
              <i>Advanced Query (Do not use unless you know what you are doing)</i>
            </div>
            <div class="columns">
              <div class="column is-2">
                <label class="label">Advanced Query:</label>
              </div>
              <div class="column is-9">
                  <v-textarea
                      outlined
                      v-model="params.advquery"
                      cols="100"
                      rows="5"
                  />
              </div>
            </div>

            <div class="columns">
              <br>
              <i>Special Text</i>
            </div>
            <div class="columns">
              <div class="column is-2">
                <label class="label">Special Text:</label>
              </div>
              <div class="column is-9">
                <froala
                    v-model="params.special_text"
                    :config="config"
                    :tag="'textarea'"
                />
              </div>
            </div>

            <div class="columns">
              <div class="column is-12 ">
                <div
                    class="control is-pulled-right"
                    @click="saveList()"
                >
                  <button
                      class="button button-tools is-mobile"
                      type="button"
                  >
                    Save Point Race
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <div class="box">
                <div class="column is-12 card-header has-text-centered button-tools">
                  <strong>Label variable legend</strong>
                </div>
                <b>[THISYEAR]</b> Replaces [THISYEAR] with the current year (Example: 2010)<br>
                <b>[LASTYEAR]</b> Replaces [LASTYEAR] with the last year (Example: 2009)<br>
                <b>[THISMONTHNAME]</b> Replaces [THISMONTHNAME] with this month's shortened name (Example: Dec)<br>
                <b>[LASTMONTHNAME]</b> Replaces [LASTMONTHNAME] with last month's shortened name (Example: Nov)<br>
                <b>[LASTMONTHYEAR]</b> Replace [LASTMONTHYEAR] with last month's shortened name and year (Example: Nov
                2010)<br>
                <b>[THISFULLMONTH]</b> Replaces [THISFULLMONTH] with this month's name (Example: Decemeber)<br>
                <b>[LASTFULLMONTH]</b> Replaces [LASTFULLMONTH] with last month's name (Example: November)<br>
                <b>[LASTFULLMONTHYEAR]</b> Replace [LASTFULLMONTHYEAR] with last month's name and year (Example:
                November 2010)<br>
                <b>[LASTWEEKSTART]</b> Replaces [LASTWEEKSTART] with the start of last week's date (Example:
                12-20-2010)<br>
                <b>[LASTWEEKEND]</b> Replaces [LASTWEEKEND] with the end of last week's date (Example: 12-26-2010)<br>
                <b>[THISWEEKSTART]</b> Replaces [THISWEEKSTART] with the start of this week's date (Example:
                12-27-2010)<br>
                <b>[THISWEEKEND]</b> Replaces [THISWEEKEND] with the end of this week's date (Example: 01-02-2011)<br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>

<script>
import Vue from 'vue'
import axios from 'axios'
import PrettyCheckbox from 'pretty-checkbox-vue'
import vSelect from 'vue-select'


Vue.component('p-check', PrettyCheckbox)
export default {
  name: 'ToolsListAdd',
  filters: {
    readableRegion: function (r) {
      return r.toString() === '0' ? 'All Regions' : 'Region: ' + r
    }
  },
  components: {
    'v-select': vSelect,
  },
  props: ['user', 'token'],
  data() {
    return {
      lists: [],
      eventTags:[],
      config: {
        key: 'GPD2tA17B2A2C1A1B1sqyI-7cB-22C-16seD2zuvc1A6B5A4D3A3B2B2G3A4A3==',
        imageUploadParam: 'file',
        imageUploadURL: 'https://rest.ahlpoker.com/image/upload',
        imageUploadParams: {
          id: 'my_editor',
          token: ''
        },
        imageUploadMethod: 'POST',
        imageMaxSize: 5 * 1024 * 1024,
        imageAllowedTypes: ['jpeg', 'jpg', 'png'],
        imageManagerLoadMethod: 'GET',
        imageManagerLoadURL: 'https://rest.ahlpoker.com/image/getlist',
        imageManagerDeleteURL: 'https://rest.ahlpoker.com/image/delete',
        events: {
          'froalaEditor.image.loaded': (e, editor, $img) => {
            this['_data'].images.push($img[0].src)
          },
          'froalaEditor.image.removed': (e, editor, $img) => {
            let index = this['_data'].images.find((image) => {
              return image === $img[0].src
            })
            this['_data'].images.splice(index, 1)
          }
        },
      },
      showLoading: false,
      searchActive: true,
      franchises: [],
      params: {
        active: true,
        name: '',
        tablabel: '',
        torder: 0,
        franchise: null,
        retcount: 50,
        lastcurr: null,
        special_text: null,
        venid: null,
        advquery: null,
        helplink: null,
        helptext: null,
        list_label: null,
        tmark: null,
        date1: null,
        date2: null,
        pttable: null,
        type: null,
        manahlnums: null,
      },
      listTypes: [
        {name: 'Overall', value: 0},
        {name: 'Year', value: 1},
        {name: 'Month', value: 2},
        {name: 'Week', value: 3},
        {name: 'Date Range', value: 4},
        {name: 'Manual', value: 5}
      ],
      pointTypes: [
        {name: 'Overall', value: 'Overall'},
        {name: 'Texas Hold\'em', value: 'Texas_Holdem'},
        {name: 'AHL TV', value: 'AHLTV'},
      ],
      selectedPointType: {name: 'Overall', value: 'Overall'},
      selectedListType: {name: 'Overall', value: 0},
      selectedFranchise: null,
      receivedFranchises: false,
    }
  },
  computed: {},
  watch: {},
  created() {
    if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
  },
  mounted() {
    this.getFranchises();
    this.getEventTags();
  },
  methods: {
    getEventTags() {
      let url = `admin/tags`
      let data = {
        token: this.token
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            console.log(res)

            this.eventTags = res.data;
          })
          .catch((error) => {
            console.log(error)
          })
    },
    getFranchises() {
      let url = `admin/lists/getfranchises`
      let data = {
        token: this.token
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            console.log(res)
            this.franchises = res.data
            this.selectedFranchise = res.data[0]
            this.receivedFranchises = true
            this.getList()
          })
          .catch((error) => {
            console.log(error)
          })
    },
    getList() {
      this.params.franchise = this.selectedFranchise.id
      this.params.type = this.selectedListType.value
      this.params.pttable = this.selectedPointType.value
      this.showLoading = true
      this.$axios({
        method: 'POST',
        url: '/admin/lists/gettab/' + this.$route.params.id,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.token,
        }
      })
          .then((res) => {
            this.showLoading = false
            if (res.data.error) {
              this.$emit('message',
                  {
                    showDialog: true,
                    error: true,
                    message: res.data.message
                  })
            } else {
              this.params = res.data
              this.params.active = res.data.active.toString() === '1'
              this.selectedFranchise = this.franchises.filter((x) => {
                return x.id.toString() === res.data.franchise.toString()
              })
              this.selectedFranchise = this.selectedFranchise[0]
              this.selectedPointType = this.pointTypes.filter((x) => {
                return x.value.toString() === res.data.pttable.toString()
              })
              this.selectedPointType = this.selectedPointType[0]
              this.selectedListType = this.listTypes.filter((x) => {
                return x.value.toString() === res.data.type.toString()
              })
              this.selectedListType = this.selectedListType[0]
            }
          })
          .catch((error) => {
            this.showLoading = false
            this.$emit('message',
                {
                  showDialog: true,
                  error: true,
                  message: error
                })
            console.log(error)
          })
    },
    saveList() {
      this.params.franchise = this.selectedFranchise.id.toString()
      this.params.eventTag = this.params.eventTag && this.params.eventTag.id
      this.params.type = this.selectedListType.value
      this.params.pttable = this.selectedPointType.value
      this.showLoading = true
      this.$axios({
        method: 'POST',
        url: '/admin/lists/edittab/' + this.$route.params.id,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.token,
          params: this.params,
        }
      })
          .then((res) => {
            this.showLoading = false
            this.$emit('message',
                {
                  showDialog: true,
                  error: res.data.error,
                  message: res.data.message
                })
          })
          .catch((error) => {
            this.showLoading = false
            this.$emit('message',
                {
                  showDialog: true,
                  error: true,
                  message: error
                })
            console.log(error)
          })
    },
  }
}
</script>
